import { isSyntheticEmail } from "./isSyntheticEmail";

export function hasVerifiedAccountEmail(user: { email: string; emailVerified: boolean }): boolean {
  return user.emailVerified && !isSyntheticEmail(user.email);
}
